import { onBeforeUnmount, onMounted, watch, type Ref } from 'vue';

type VisibilitySource = Ref<boolean> | (() => boolean);

/**
 * Закрывает раскрытое поле поиска по нажатию Escape.
 * Слушатель document навешивается только на клиенте (в onMounted) — безопасно для SSR,
 * а его снятие регистрируется на верхнем уровне setup через onBeforeUnmount,
 * а не вложенно в onMounted.
 */
export function useCloseOnEscape(visible: VisibilitySource, onClose: () => void): void {
  const isVisible = (): boolean => (typeof visible === 'function' ? visible() : visible.value);

  const handleKeydown = (event: KeyboardEvent): void => {
    if (event.key === 'Escape') {
      onClose();
    }
  };

  const removeListener = (): void => {
    document.removeEventListener('keydown', handleKeydown);
  };

  onMounted(() => {
    watch(
      isVisible,
      (visibleNow) => {
        if (visibleNow) {
          document.addEventListener('keydown', handleKeydown);
        } else {
          removeListener();
        }
      },
      { immediate: true },
    );
  });

  onBeforeUnmount(removeListener);
}
